module.exports = __webpack_public_path__ + "media/images/europa_logo-0954d64db293c6569a696f6fca1b1106.jpg";